import { IRetailerProductBasedCollectionResponse } from "@faire/web-api/indigofair/data/IRetailerProductBasedCollectionResponse";
import { HorizontalLine } from "@faire/web/slate/Layout";
import * as React from "react";

import { Breadcrumb, IBreadcrumbOption } from "@faire/retailer/components/Breadcrumb";
import { brandPage } from "@faire/retailer/paths";

interface IProductBasedCollectionBreadcrumbProps {
  collection: IRetailerProductBasedCollectionResponse.IRetailerProductBasedCollection;
}

export const ProductBasedCollectionBreadcrumb: React.FC<
  IProductBasedCollectionBreadcrumbProps
> = ({ collection }) => {
  const breadcrumbOptions: IBreadcrumbOption[] = [];

  // Next the brand hosting the collection.
  if (collection.brand_name && collection.brand_token) {
    breadcrumbOptions.push({
      label: collection.brand_name,
      path: brandPage(collection.brand_token),
    });
  }

  // Lastly, the name of the collection.
  if (collection.name) {
    breadcrumbOptions.push({
      label: collection.name,
    });
  }

  return (
    <>
      <Breadcrumb options={breadcrumbOptions} />
      <HorizontalLine />
    </>
  );
};
